require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.for-each");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

var t = e(require("jwt-decode")),
    n = require("react"),
    r = e(n),
    o = function o() {
  return "undefined" != typeof window;
},
    i = "_identity_user",
    l = [];

function s() {
  return o() && window.localStorage.getItem(i) ? JSON.parse(window.localStorage.getItem(i)) : null;
}

function a(e) {
  var t = window.localStorage.setItem(i, JSON.stringify(e));
  return l.forEach(function (t) {
    return t(e);
  }), t;
}

function u(e) {
  return l.push(e), function () {
    l = l.filter(function (t) {
      return t === e;
    });
  };
}

function c(e, t) {
  try {
    var n = e();
  } catch (e) {
    return t(e);
  }

  return n && n.then ? n.then(void 0, t) : n;
}

function m(e, t) {
  try {
    var n = e();
  } catch (e) {
    return t(!0, e);
  }

  return n && n.then ? n.then(t.bind(null, !1), t.bind(null, !0)) : t(!1, n);
}

"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));

var d = null,
    f = {
  get baseURL() {
    if (!d) throw new Error("Identity API must be configured before being called");
    return d;
  }

},
    p = function p(e) {
  var t = e.id,
      n = e.scope;

  try {
    var r = s();
    if (!r || !t || !n) return Promise.resolve(null);
    var o = f.baseURL + "/users/" + t + "/scopes/" + encodeURIComponent(n);
    return Promise.resolve(c(function () {
      return Promise.resolve(fetch(o, {
        method: "DELETE",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + r.token
        }
      })).then(function (e) {
        return Promise.resolve(e.json()).then(function (e) {
          var t = e.user;
          return r.id === t.id ? (t.token = r.token, a(t), t) : r;
        });
      });
    }, function () {
      return console.log("error removing scope"), null;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
},
    v = function v(e) {
  var t = e.id,
      n = e.scope;

  try {
    var r = s();
    if (!r || !t || !n) return Promise.resolve(null);
    var o = f.baseURL + "/users/" + t + "/scopes/" + encodeURIComponent(n);
    return Promise.resolve(c(function () {
      return Promise.resolve(fetch(o, {
        method: "PUT",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + r.token
        }
      })).then(function (e) {
        return Promise.resolve(e.json()).then(function (e) {
          var t = e.user;
          return r.id === t.id ? (t.token = r.token, a(t), t) : r;
        });
      });
    }, function (e) {
      return console.log("error adding scope", e), null;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
},
    h = function h(e) {
  var t = e.id;

  try {
    var n = s();
    if (!n) return Promise.resolve(null);
    var r = f.baseURL + "/users/" + t;
    return Promise.resolve(c(function () {
      return Promise.resolve(fetch(r, {
        method: "DELETE",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + n.token
        }
      })).then(function (e) {
        return Promise.resolve(e.json());
      });
    }, function () {
      return null;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
},
    y = function y(e) {
  var t = e.name,
      n = e.email,
      r = e.password;

  try {
    var o = s();
    if (!o) return Promise.resolve(null);
    var i = f.baseURL + "/users";
    return Promise.resolve(c(function () {
      return Promise.resolve(fetch(i, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + o.token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: t,
          email: n,
          password: r
        })
      })).then(function (e) {
        return Promise.resolve(e.json());
      });
    }, function () {
      return null;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
},
    b = function b() {
  try {
    var e = s();
    if (!e) return Promise.resolve(null);
    var t = f.baseURL + "/users";
    return Promise.resolve(c(function () {
      return Promise.resolve(fetch(t, {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + e.token
        }
      })).then(function (e) {
        return Promise.resolve(e.json()).then(function (e) {
          return e.users;
        });
      });
    }, function () {
      return null;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
},
    g = function g(e) {
  var n = e.email,
      r = e.password;

  try {
    var o = f.baseURL + "/login";
    return Promise.resolve(c(function () {
      return Promise.resolve(fetch(o, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: n,
          password: r
        })
      })).then(function (e) {
        return Promise.resolve(e.json()).then(function (e) {
          var n = e.token,
              r = t(n).user;
          return r.token = n, a(r), r;
        });
      });
    }, function (e) {
      return console.log("Failed to log in.", e), null;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

function E(e) {
  var t = e.onLogin,
      o = n.useState(!1),
      i = o[0],
      l = o[1];
  return r.createElement("form", {
    name: "login",
    method: "post",
    style: P.form,
    onSubmit: function onSubmit(e) {
      try {
        e.stopPropagation(), e.preventDefault();
        var n = e.target.elements,
            r = n.email.value,
            o = n.password.value;
        return l(!0), Promise.resolve(g({
          email: r,
          password: o
        })).then(function (e) {
          e && t(e), l(!1);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, r.createElement("input", {
    type: "hidden",
    name: "bot-field"
  }), r.createElement("label", {
    style: P.row
  }, "Email ", r.createElement("input", {
    type: "email",
    name: "email",
    id: "email",
    disabled: i
  })), r.createElement("label", {
    style: P.row
  }, "Password ", r.createElement("input", {
    type: "password",
    name: "password",
    id: "password",
    disabled: i
  })), r.createElement("button", {
    type: "submit",
    style: P.submit,
    disabled: i
  }, "Submit"));
}

var P = {
  form: {
    display: "flex",
    flexDirection: "column"
  },
  row: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "20px"
  },
  submit: {
    borderRadius: "50px",
    padding: "0.2rem 1rem",
    alignSelf: "flex-end",
    fontSize: "14px",
    fontWeight: "bold",
    fontFamily: '"SFMono-Regular", Consolas, "Roboto Mono", "Droid Sans Mono",\n    "Liberation Mono", Menlo, Courier, monospace'
  }
};
E.defaultProps = {
  onLogin: function onLogin() {}
};
var S = {
  form: {
    display: "flex",
    flexDirection: "column"
  },
  row: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "20px"
  },
  submit: {
    borderRadius: "50px",
    padding: "0.2rem 1rem",
    alignSelf: "flex-end",
    fontSize: "14px",
    fontWeight: "bold",
    fontFamily: '"SFMono-Regular", Consolas, "Roboto Mono", "Droid Sans Mono",\n    "Liberation Mono", Menlo, Courier, monospace',
    whiteSpace: "pre"
  },
  linkRow: {
    padding: "0.2rem 0.5rem",
    borderLeft: "2px solid rgba(224, 219, 255, 1)",
    backgroundColor: "rgba(224, 219, 255, 0.5)",
    marginTop: "2px",
    display: "flex",
    fontSize: "13px",
    fontFamily: '"SFMono-Regular", Consolas, "Roboto Mono", "Droid Sans Mono",\n    "Liberation Mono", Menlo, Courier, monospace'
  },
  inlineLink: {
    cursor: "pointer",
    alignSelf: "flex-end",
    fontSize: "13px",
    fontFamily: '"SFMono-Regular", Consolas, "Roboto Mono", "Droid Sans Mono",\n    "Liberation Mono", Menlo, Courier, monospace',
    whiteSpace: "pre"
  },
  inlineFormElement: {
    flex: 1,
    padding: "0.2rem 0.5rem",
    margin: "0 1rem 0 0",
    fontSize: "13px",
    fontFamily: '"SFMono-Regular", Consolas, "Roboto Mono", "Droid Sans Mono",\n    "Liberation Mono", Menlo, Courier, monospace'
  },
  destructiveButton: {
    color: "rgb(197, 4, 4)"
  }
};
exports.configure = function (e) {
  "baseURL" in e && (d = e.baseURL);
}, exports.LoginForm = E, exports.AdminControls = function () {
  var e = n.useState([]),
      t = e[0],
      o = e[1],
      i = n.useState(!1),
      l = i[0],
      s = i[1];
  return n.useEffect(function () {
    b().then(function (e) {
      e && o(e);
    });
  }, []), r.createElement(r.Fragment, null, r.createElement("h4", null, "Add User"), r.createElement("form", {
    name: "addUser",
    method: "post",
    onSubmit: function onSubmit(e) {
      try {
        e.stopPropagation(), e.preventDefault();
        var t = e.target.elements,
            n = t.name.value,
            r = t.email.value,
            i = t.password.value;
        e.target.reset();
        var l = m(function () {
          return s(!0), Promise.resolve(y({
            name: n,
            email: r,
            password: i
          })).then(function () {
            return Promise.resolve(b()).then(function (e) {
              e && o(e);
            });
          });
        }, function (e, t) {
          if (s(!1), e) throw t;
          return t;
        });
        return Promise.resolve(l && l.then ? l.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    style: {
      flex: 1,
      display: "flex",
      flexDirection: "row"
    }
  }, r.createElement("input", {
    type: "text",
    name: "name",
    id: "name",
    placeholder: "Name",
    disabled: l,
    style: S.inlineFormElement
  }), r.createElement("input", {
    type: "email",
    name: "email",
    id: "email",
    placeholder: "Email",
    disabled: l,
    style: S.inlineFormElement
  }), r.createElement("input", {
    type: "text",
    name: "password",
    id: "password",
    placeholder: "Password",
    disabled: l,
    style: S.inlineFormElement
  }), r.createElement("button", {
    type: "submit",
    style: S.submit,
    disabled: l
  }, "Add User")), r.createElement("hr", null), r.createElement("h4", null, "Users"), r.createElement("table", null, r.createElement("thead", null, r.createElement("tr", null, r.createElement("td", null, "NAME"), r.createElement("td", null, "EMAIL"), r.createElement("td", null, "ADMIN"), r.createElement("td", null, "PAGE ACCESS"), r.createElement("td", null, "DELETE"))), r.createElement("tbody", null, t.map(function (e) {
    return r.createElement("tr", {
      key: e.id
    }, r.createElement("td", {
      style: {
        whiteSpace: "pre"
      }
    }, e.name, " (", e.id, ")"), r.createElement("td", null, e.email), r.createElement("td", null, e.scopes.includes("admin").toString()), r.createElement("td", {
      style: {
        backgroundColor: "rgba(0,0,0,0.03)"
      }
    }, r.createElement("form", {
      style: {
        display: "flex",
        marginBottom: e.scopes.length > 0 ? "12px" : "0px"
      },
      onSubmit: function onSubmit(t) {
        try {
          t.stopPropagation(), t.preventDefault();
          var n = t.target.elements.page.value;
          if (t.target.reset(), !n) return Promise.resolve();
          var r = m(function () {
            return s(!0), Promise.resolve(v({
              id: e.id,
              scope: n
            })).then(function () {
              return Promise.resolve(b()).then(function (e) {
                e && o(e);
              });
            });
          }, function (e, t) {
            if (s(!1), e) throw t;
            return t;
          });
          return Promise.resolve(r && r.then ? r.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }, r.createElement("input", {
      type: "text",
      name: "page",
      placeholder: "Page",
      disabled: l,
      style: S.inlineFormElement
    }), r.createElement("button", {
      type: "submit",
      style: S.submit,
      disabled: l
    }, "ADD PAGE")), e.scopes.map(function (t, n) {
      return r.createElement("div", {
        key: n,
        style: S.linkRow
      }, r.createElement("span", {
        style: {
          flex: "1 1 auto"
        }
      }, t), "admin" !== t && r.createElement("a", {
        style: Object.assign({}, S.inlineLink, S.destructiveButton),
        onClick: function onClick() {
          try {
            var n = m(function () {
              return s(!0), Promise.resolve(p({
                id: e.id,
                scope: t
              })).then(function () {
                return Promise.resolve(b()).then(function (e) {
                  e && o(e);
                });
              });
            }, function (e, t) {
              if (s(!1), e) throw t;
              return t;
            });
            return Promise.resolve(n && n.then ? n.then(function () {}) : void 0);
          } catch (e) {
            return Promise.reject(e);
          }
        }
      }, "Remove"));
    })), r.createElement("td", null, r.createElement("button", {
      style: Object.assign({}, S.submit, S.destructiveButton),
      disabled: l,
      onClick: function onClick(t) {
        try {
          if (!window.confirm("Are you sure you want to delete the user " + e.name + " (" + e.id + ")?")) return Promise.resolve();
          var n = m(function () {
            return s(!0), Promise.resolve(h({
              id: e.id
            })).then(function () {
              return Promise.resolve(b()).then(function (e) {
                e && o(e);
              });
            });
          }, function (e, t) {
            if (s(!1), e) throw t;
            return t;
          });
          return Promise.resolve(n && n.then ? n.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }, "DELETE")));
  }))));
}, exports.getUser = s, exports.setUser = a, exports.addUserListener = u, exports.removeScope = p, exports.addScope = v, exports.deleteUser = h, exports.createUser = y, exports.getUsers = b, exports.login = g, exports.isLoggedIn = function () {
  return !!s();
}, exports.logout = function () {
  return a(null);
}, exports.isAdmin = function (e) {
  return !!e && e.scopes.includes("admin");
}, exports.canAccessPath = function (e, t) {
  return void 0 === t && (t = "/"), !!e && e.scopes.includes(t.slice(1));
}, exports.useUser = function () {
  var e = n.useState(s()),
      t = e[0],
      r = e[1];
  return n.useEffect(function () {
    return u(r);
  }), t;
};